import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
// import { reportToDMP } from './requests/report.js'

Vue.use(VueRouter)

// let timeBegin
// const DETAIL_NAME_LIST = ['detail-news', 'detail-video', 'detail-short']
// window.path_list = []

//处理NavigationDuplicated报错的问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location)
}

// 初始化路由实例
const router = new VueRouter({
    routes
})

// 全局前置守卫
// router.beforeEach((to, from, next) => {
//   next()
// })

// 全局后置守卫
// router.afterEach((to, from) => {
// })

export default router
